import axios from '@/axios-setup'
// import store from '@/store'
import router from '@/router'
import { throwError } from '@/utils/helpers'
import { EventsApiType } from '@/types/apiTypes'

const entityUrl = '/event'

// TODO: Replace the eventId param with getVenueID()
// const getVenueId = (): string => store.state?.venue?.venueInfo?.id
// TODO: Add Router type
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const getEventId = (): string => router?.history?.current?.params?.eventId

const eventApi: EventsApiType = {
	getEvents(params) {
		const { venueId } = params

		if (!venueId) throwError('venue id is required')

		return axios.get(entityUrl, { params })
	},

	getEventById(id) {
		if (!id) throwError('event id is required')

		return axios.get(`${entityUrl}/${id}`)
	},

	getEventOrder(eventId) {
		if (!eventId) throwError('event id is required')

		return axios.get(
			`ticketOrder`,
			{ params: { eventId } },
			{ skipError: true }
		)
	},

	updateEventOrder(payload) {
		return axios.patch(`ticketOrder/${payload.orderId}`, payload)
	},

	verifyPhone(payload) {
		return axios.post(`unsignedUser/sendPhoneCode`, payload)
	},

	verifyEmail(payload) {
		return axios.post(`/unsignedUser/sendConfirmEmail`, payload)
	},

	sendPhoneCode(payload) {
		return axios.post(
			`unsignedUser/verifyPhoneCode`,
			payload,
			{},
			{
				skipError: true
			}
		)
	},

	reserveTickets(orderId) {
		return axios.post(
			`ticketOrder/${orderId}/reserve`,
			{},
			{},
			{ skipError: true }
		)
	},

	purchaseTickets(orderId) {
		return axios.post(
			`ticketOrder/${orderId}/purchase`,
			{},
			{},
			{ skipError: true }
		)
	},

	getEventPurchaseOrder(eventPurchaseOrderId, domain, venueId) {
		return axios.get(
			`/eventPurchaseOrder/${eventPurchaseOrderId}?venueChainDomain=${domain}&venueLocalId=${venueId}`
		)
	},

	getInfoByTicketQRCode(ticketId, domain, venueId) {
		return axios.get(
			`/qrCode/${ticketId}?venueChainDomain=${domain}&venueLocalId=${venueId}`
		)
	},

	getEventsDates(venueId) {
		return axios.get(`/event/dates?venueId=${venueId}`)
	},

	getEventTicket(data) {
		return axios.get(
			`/eventTicket/${data.eventTicketId}?venueId=${data.venueId}`
		)
	},

	getEventAvailableTickets(phone) {
		const eventId = getEventId()

		if (!eventId) throw Error('eventId is required')

		return axios.get('/event/availableTickets', {
			params: {
				eventId,
				phone
			}
		})
	},

	addTicketTierItemToOrder(data) {
		return axios.post('/ticketOrder/addItem', data)
	},

	updateTicketTierItemInOrder(id, data) {
		return axios.patch(`/ticketOrder/updateItem/${id}`, data)
	}
}

export default eventApi
